var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymceEditor"},[_c('vue-tinymce',{attrs:{"setting":Object.assign({}, _vm.setting, _vm.extraSetting)},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }